import { Injectable } from "@angular/core";
import { IID_RISORSE_PERMESSO_PUBBLICO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { ActionService } from "@ep-om/project/state/action/action.service";
import { CrudService } from "@ep-om/project/state/crudService";
import { ProjectEntityStoreStrategy } from "@ep-om/project/state/updateStoreStrategies";
import { IIDRisorsePermessoPubblicoQuery } from "./iidRisorsePermessoPubblico.query";
import { IIDRisorsePermessoPubblicoStore } from "./iidRisorsePermessoPubblico.store";
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RISORSE_PERMESSO_PUBBLICO)
export class IIDRisorsePermessoPubblicoService extends CrudService<IID_RISORSE_PERMESSO_PUBBLICO, IIDRisorsePermessoPubblicoStore, IIDRisorsePermessoPubblicoQuery> {
  constructor(
    protected store: IIDRisorsePermessoPubblicoStore,
    public query: IIDRisorsePermessoPubblicoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy
  ) {
    super(Topics.IID_RISORSE_PERMESSO_PUBBLICO, store, query, actionService, updateStrategy);
  }
}
